(function () {
  'use strict';

  if (window.__CL_WEB_SIGNALS_V2__) return;
  window.__CL_WEB_SIGNALS_V2__ = true;

  var ENDPOINT = 'https://hook.us2.make.com/b9ywustuhqmd89dp8pn324imhv62i9if';
  var THEME_ID = '205747618078';
  var SHOP = 'j0pgjz-sq.myshopify.com';
  var HOSTS = ['chris-lake.com', 'www.chris-lake.com'];
  var BUILD = 'cl-web-signals-20260915-v3';
  var ATTRIBUTION_KEY = 'cl_web_signal_attribution_v2';
  var SENT_KEY = 'cl_web_signal_sent_v2';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var leftSent = false;
  var hiddenTimer = null;
  var engaged = false;
  var navigating = false;
  var VIDEO_THRESHOLD_SECONDS = 30;
  var VIDEO_THRESHOLD_PERCENT = 0.5;

  function isProduction() {
    try {
      var shopify = window.Shopify;
      return Boolean(
        shopify &&
        shopify.shop === SHOP &&
        shopify.theme &&
        shopify.theme.role === 'main' &&
        HOSTS.indexOf(window.location.hostname) !== -1 &&
        window.location.protocol === 'https:' &&
        !shopify.designMode &&
        !shopify.visualPreviewMode &&
        !shopify.inspectMode
      );
    } catch (error) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.marketingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function safe(value) {
    var text = String(value || '').trim();
    return text.length <= 300 ? text : text.slice(0, 300);
  }

  function validEmail(value) {
    var email = safe(value).toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
  }

  function readStorage(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeStorage(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function id() {
    return window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function pageHandle() {
    if (window.__CL_PAGE_HANDLE__) return safe(window.__CL_PAGE_HANDLE__);
    return safe(window.location.pathname.replace(/^\/+|\/+$/g, '').replace(/\//g, '_')) || 'home';
  }

  function pageType() {
    var path = window.location.pathname.toLowerCase();
    if (path === '/' || path === '') return 'home';
    if (/^\/products\//.test(path)) return 'product';
    if (/^\/collections\//.test(path)) return 'collection';
    if (/^\/blogs\//.test(path)) return 'article';
    if (/^\/pages\//.test(path)) return 'page';
    if (/^\/cart/.test(path)) return 'cart';
    if (/^\/checkout/.test(path)) return 'checkout';
    return 'page';
  }

  function firstAttribute(node, attributes) {
    var current = node;
    for (var i = 0; i < attributes.length; i += 1) {
      if (current && current.getAttribute) {
        var value = safe(current.getAttribute(attributes[i]));
        if (value) return value;
      }
    }
    return '';
  }

  function nearestAttribute(node, attribute) {
    if (!node || !node.closest) return '';
    var match = node.closest('[' + attribute + ']');
    return match ? safe(match.getAttribute(attribute)) : '';
  }

  function entityMetadata(target) {
    var node = target && target.closest ? target.closest('[data-cl-entity-id]') : null;
    if (!node) node = document.querySelector('[data-cl-entity-id]');
    var type = firstAttribute(node, ['data-cl-entity-type']);
    var entityId = firstAttribute(node, ['data-cl-entity-id']);
    var status = firstAttribute(node, ['data-cl-entity-status']);
    var start = firstAttribute(node, ['data-cl-event-start']);
    var end = firstAttribute(node, ['data-cl-event-end']);
    var restockWindow = firstAttribute(node, ['data-cl-restock-window']);
    var activeCampaign = campaign();
    if (!entityId && activeCampaign === 'head_trip') {
      type = type || 'event';
      entityId = 'head-trip-2026';
      status = status || 'active';
      start = start || '2026-10-10';
      end = end || '2026-10-11';
      restockWindow = restockWindow || 'post_event';
    }
    return {
      entity_type: safe(type),
      entity_id: safe(entityId),
      entity_status: safe(status),
      event_start_at: safe(start),
      event_end_at: safe(end),
      restock_window: safe(restockWindow)
    };
  }

  function campaign() {
    var node = document.querySelector('[data-cl-campaign]');
    var declared = safe((node && node.getAttribute('data-cl-campaign')) || window.__CL_CAMPAIGN__);
    if (declared === 'head_trip_2026') return 'head_trip';
    if (declared) return declared;
    var handle = pageHandle().toLowerCase();
    if (handle.indexOf('head-trip') !== -1) return 'head_trip';
    if (/collection[-_]?003|drop[-_]?003/.test(handle)) return 'collection_003';
    if (/music|song|release|discography|tracks?/.test(handle)) return 'music';
    if (/network|community|discord/.test(handle)) return 'network';
    if (/show|tour|ticket/.test(handle)) return 'tickets';
    return 'site';
  }

  function currentAttribution(target) {
    var stored = readStorage(ATTRIBUTION_KEY);
    var now = Date.now();
    if (!stored.started || now - stored.touched > MAX_AGE) stored = {started: now, first: {}, last: {}};
    if (!stored.first) stored.first = {};
    if (!stored.last) stored.last = {};

    var sources = [];
    try { sources.push(new URL(window.location.href)); } catch (error) {}
    if (target) {
      try { sources.push(new URL(target, window.location.href)); } catch (error) {}
    }

    var current = {};
    sources.forEach(function (source) {
      UTM_KEYS.forEach(function (key) {
        var value = safe(source.searchParams.get(key));
        if (value) current[key] = value;
      });
    });

    if (Object.keys(current).length) {
      if (!Object.keys(stored.first).length) stored.first = Object.assign({}, current);
      stored.last = Object.assign({}, stored.last, current);
    }
    stored.touched = now;
    writeStorage(ATTRIBUTION_KEY, stored);

    var result = {};
    UTM_KEYS.forEach(function (key) {
      if (stored.last[key]) result[key] = stored.last[key];
    });
    return result;
  }

  function identifyFromQueue() {
    try {
      var queue = window._learnq;
      if (!Array.isArray(queue)) return '';
      for (var i = queue.length - 1; i >= 0; i -= 1) {
        var item = queue[i];
        if (!Array.isArray(item) || item[0] !== 'identify') continue;
        var data = item[1] || {};
        var email = validEmail(data.$email || data.email || data.email_address);
        if (email) return email;
      }
    } catch (error) {}
    return '';
  }

  function emailFromForm(form) {
    if (!form || !form.elements) return '';
    var field = form.elements.email || form.elements.email_address || form.querySelector('input[type="email"]');
    return validEmail(field && field.value);
  }

  function profileEmail(form) {
    return emailFromForm(form) || validEmail(window.__CL_PROFILE_EMAIL__) || identifyFromQueue();
  }

  function consentState(form, eventType) {
    var state = {email: false, sms: false, source: 'website_signal'};
    if (eventType !== 'form_submitted' || !form || !form.querySelector) return state;
    var emailConsent = form.querySelector('input[name="email_consent"]');
    var smsConsent = form.querySelector('input[name="sms_consent"]');
    state.email = Boolean(emailConsent && emailConsent.checked);
    state.sms = Boolean(smsConsent && smsConsent.checked);
    state.source = form.matches && form.matches('[data-cl-network-form]') ? 'network_form' : 'website_form';
    return state;
  }

  function signalForm(form) {
    if (!form || !form.matches) return false;
    if (form.matches('form[data-cl-signal-form], form[data-cl-event-form], form[data-cl-network-form]')) return true;
    var action = safe(form.getAttribute('action')).toLowerCase();
    if (/\/account\/login|\/search/.test(action)) return false;
    return Boolean(form.querySelector('input[type="email"], input[name="email"], input[name="email_address"]'));
  }

  function alreadySent(eventType, target) {
    var sent = readStorage(SENT_KEY);
    var key = eventType + '|' + safe(target || window.location.pathname);
    if (sent[key]) return true;
    sent[key] = Date.now();
    var keys = Object.keys(sent);
    if (keys.length > 150) delete sent[keys[0]];
    writeStorage(SENT_KEY, sent);
    return false;
  }

  function linkFor(target) {
    var link = target && target.closest ? target.closest('a[href]') : null;
    return link || null;
  }

  function buttonFor(target) {
    var button = target && target.closest ? target.closest('button, [role="button"]') : null;
    if (!button) return null;
    if (button.hasAttribute('data-cl-event') || button.hasAttribute('data-cl-product-id') || button.hasAttribute('data-cl-network-open')) return button;
    return null;
  }

  function eventTypeFor(link) {
    if (!link) return '';
    var explicit = safe(link.getAttribute('data-cl-event'));
    var contentType = firstAttribute(link, ['data-cl-content-type', 'data-cl-media-kind']).toLowerCase();
    var raw = firstAttribute(link, ['data-cl-product-url', 'data-cl-destination', 'data-cl-url', 'href']);
    var href = '';
    try { href = new URL(raw || window.location.href, window.location.href).href; } catch (error) { return ''; }

    if (explicit === 'laylo_fallback_click') return 'laylo_click';
    if (firstAttribute(link, ['data-cl-product-id'])) return 'product_click';
    if (explicit === 'youtube_click') return 'youtube_click';
    if (explicit === 'song_click') return 'music_click';
    if (['ticket_click', 'laylo_click', 'livestream_click', 'campaign_click', 'page_click', 'page_engaged', 'interest_selected', 'form_submitted', 'page_left', 'product_click', 'show_click', 'music_click', 'song_click', 'network_click', 'network_discord_clicked'].indexOf(explicit) !== -1) return explicit;
    if (contentType === 'song' || contentType === 'track') return 'music_click';
    if (contentType === 'music' || contentType === 'audio' || contentType === 'release') return 'music_click';
    if (/axs\.com/i.test(href)) return 'ticket_click';
    if (/laylo\.com/i.test(href)) return 'laylo_click';
    if (/discord\.com|discord\.gg/i.test(href)) return 'network_discord_clicked';
    if (/spotify\.com|music\.apple\.com|soundcloud\.com|beatport\.com|tidal\.com|music\.amazon\.com|bandcamp\.com/i.test(href)) return 'music_click';
    if (/youtube\.com|youtu\.be/i.test(href)) return 'youtube_click';
    if (/vimeo\.com|twitch\.tv/i.test(href)) return 'livestream_click';
    if (/\/products\//i.test(href)) return 'product_click';
    if (/\/collections\//i.test(href)) return 'product_click';
    if (/head-trip-2026-live-stream|#head-trip-live/i.test(href)) return 'livestream_click';
    if (/head-trip-2026-tickets|\/pages\/shows|\/pages\/tour/i.test(href)) return 'show_click';
    if (/^https:\/\/(www\.)?chris-lake\.com\/pages\//i.test(href)) return 'page_click';
    if (explicit === 'campaign_click') return 'campaign_click';
    return '';
  }

  function cleanUrl(raw) {
    if (typeof raw !== 'string' || !raw.trim()) return '';
    try {
      var url = new URL(raw, window.location.href);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      var query = [];
      UTM_KEYS.forEach(function (key) {
        var value = safe(url.searchParams.get(key));
        if (value) query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return url.origin + url.pathname + (query.length ? '?' + query.join('&') : '');
    } catch (error) { return ''; }
  }

  function linkDestination(link) {
    if (!link) return '';
    var raw = firstAttribute(link, ['data-cl-product-url', 'data-cl-destination', 'data-cl-url', 'href']);
    return cleanUrl(raw || window.location.href);
  }

  function pageMetadata(target) {
    var canonical = document.querySelector('link[rel="canonical"]');
    var description = document.querySelector('meta[name="description"]');
    var eventNameMeta = document.querySelector('meta[itemprop="name"]');
    var eventCityMeta = document.querySelector('meta[itemprop="addressLocality"]');
    var eventRegionMeta = document.querySelector('meta[itemprop="addressRegion"]');
    var eventCountryMeta = document.querySelector('meta[itemprop="addressCountry"]');
    var productHandle = firstAttribute(target, ['data-cl-product-handle']);
    var productVariantId = firstAttribute(target, ['data-cl-product-variant-id']);
    var collectionHandle = firstAttribute(target, ['data-cl-collection', 'data-cl-collection-handle']);
    var collectionTitle = firstAttribute(target, ['data-cl-collection-title']);
    var showId = firstAttribute(target, ['data-cl-show-id']);
    var showName = firstAttribute(target, ['data-cl-show-name']) || safe(eventNameMeta && eventNameMeta.getAttribute('content'));
    var showCity = firstAttribute(target, ['data-cl-show-city', 'data-cl-location-city']) || safe(eventCityMeta && eventCityMeta.getAttribute('content'));
    var showRegion = firstAttribute(target, ['data-cl-show-region', 'data-cl-location-region']) || safe(eventRegionMeta && eventRegionMeta.getAttribute('content'));
    var showCountry = firstAttribute(target, ['data-cl-show-country', 'data-cl-location-country']) || safe(eventCountryMeta && eventCountryMeta.getAttribute('content'));
    var ticketVendor = firstAttribute(target, ['data-cl-ticket-vendor']);
    var songTitle = firstAttribute(target, ['data-cl-song-title', 'data-cl-track-title']);
    var artistAlias = firstAttribute(target, ['data-cl-artist', 'data-cl-artist-alias']);
    if (!productHandle) productHandle = nearestAttribute(target, 'data-cl-product-handle');
    if (!productVariantId) productVariantId = nearestAttribute(target, 'data-cl-product-variant-id');
    if (!collectionHandle) collectionHandle = nearestAttribute(target, 'data-cl-collection');
    if (!collectionTitle) collectionTitle = nearestAttribute(target, 'data-cl-collection-title');
    if (!showId) showId = nearestAttribute(target, 'data-cl-show-id');
    if (!showName) showName = nearestAttribute(target, 'data-cl-show-name');
    if (!showCity) showCity = nearestAttribute(target, 'data-cl-show-city');
    if (!showRegion) showRegion = nearestAttribute(target, 'data-cl-show-region');
    if (!showCountry) showCountry = nearestAttribute(target, 'data-cl-show-country');
    if (!ticketVendor) ticketVendor = nearestAttribute(target, 'data-cl-ticket-vendor');
    if (!songTitle) songTitle = nearestAttribute(target, 'data-cl-song-title');
    if (!artistAlias) artistAlias = nearestAttribute(target, 'data-cl-artist');
    if (!productHandle) {
      var productMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      productHandle = productMatch ? productMatch[1] : '';
    }
    if (!collectionHandle) {
      var collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
      collectionHandle = collectionMatch ? collectionMatch[1] : '';
    }
    return {
      page_type: pageType(),
      content_type: firstAttribute(target, ['data-cl-content-type']) || pageType(),
      page_title: safe(document.title),
      page_path: safe(window.location.pathname),
      canonical_url: safe(canonical && canonical.href),
      seo_title: safe(document.title),
      seo_description: safe(description && description.getAttribute('content')),
      product_handle: productHandle,
      product_variant_id: productVariantId,
      collection_handle: collectionHandle,
      collection_title: collectionTitle,
      show_id: showId,
      show_name: showName,
      show_city: showCity,
      show_region: showRegion,
      show_country: showCountry,
      ticket_vendor: ticketVendor,
      song_title: songTitle,
      artist_alias: artistAlias
    };
  }

  function locationMetadata(target, metadata) {
    var city = metadata.show_city || firstAttribute(target, ['data-cl-location-city']) || safe(window.__CL_LOCATION_CITY__);
    var region = metadata.show_region || firstAttribute(target, ['data-cl-location-region']) || safe(window.__CL_LOCATION_REGION__);
    var country = metadata.show_country || firstAttribute(target, ['data-cl-location-country']) || safe(window.__CL_LOCATION_COUNTRY__) || 'US';
    var timezone = '';
    try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (error) {}
    return {
      city: city,
      region: region,
      country: country,
      timezone: safe(timezone),
      source: city || region ? 'page_metadata' : 'shopify'
    };
  }

  function elapsedSeconds() {
    return Math.max(0, Math.floor((Date.now() - startTime) / 1000));
  }

  function scrollDepthPercent() {
    var height = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (!height) return 0;
    return Math.max(0, Math.min(100, Math.round(((window.scrollY + window.innerHeight) / height) * 100)));
  }

  function signalPayload(eventType, details, form, target, reason) {
    var email = profileEmail(form);
    if (!email || !isProduction() || !marketingAllowed()) return null;

    var metadata = pageMetadata(target);
    var entity = entityMetadata(target);
    var destination = linkDestination(target);
    var pageUrl = cleanUrl(window.location.href) || (window.location.origin + window.location.pathname);
    var contextCampaign = safe((details && details.campaign) || nearestAttribute(target, 'data-cl-campaign') || campaign());
    if (contextCampaign === 'head_trip_2026') contextCampaign = 'head_trip';
    var clickTarget = safe((details && details.click_target) || (target && (target.getAttribute('aria-label') || target.textContent)));
    var eventUrl = safe((details && details.url) || destination || pageUrl);
    var elapsed = elapsedSeconds();
    var consent = consentState(form, eventType);
    var payload = {
      schema_version: 'cl2026.v2',
      build: BUILD,
      event_id: id(),
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      profile: {email: email},
      context: {
        campaign: contextCampaign,
        page_handle: pageHandle(),
        page_url: pageUrl,
        page_type: metadata.page_type,
        content_type: safe((details && details.content_type) || metadata.content_type),
        page_title: metadata.page_title,
        page_path: metadata.page_path,
        canonical_url: metadata.canonical_url,
        seo_title: metadata.seo_title,
        seo_description: metadata.seo_description,
        placement: safe((details && details.placement) || firstAttribute(target, ['data-cl-placement']) || eventType),
        source: 'chris-lake.com',
        referrer: safe(document.referrer),
        interest: safe((details && details.interest) || firstAttribute(target, ['data-cl-interest'])),
        page_item: metadata.page_type + ':' + (metadata.product_handle || metadata.collection_handle || metadata.show_id || pageHandle()),
        show_id: metadata.show_id,
        show_name: metadata.show_name,
        show_city: metadata.show_city,
        show_region: metadata.show_region,
        show_country: metadata.show_country,
        ticket_vendor: metadata.ticket_vendor,
        song_title: metadata.song_title,
        artist_alias: metadata.artist_alias,
        collection_title: metadata.collection_title,
        location: locationMetadata(target, metadata),
        entity_type: entity.entity_type,
        entity_id: entity.entity_id,
        entity_status: entity.entity_status,
        event_start_at: entity.event_start_at,
        event_end_at: entity.event_end_at,
        restock_window: entity.restock_window
      },
      utm: currentAttribution(eventUrl),
      event: {
        destination: safe((details && details.destination) || destination),
        url: eventUrl,
        link_text: clickTarget,
        click_target: clickTarget,
        drop_id: safe((details && details.drop_id) || firstAttribute(target, ['data-cl-drop-id'])),
        product_id: safe((details && details.product_id) || firstAttribute(target, ['data-cl-product-id'])),
        product_title: safe((details && details.product_title) || firstAttribute(target, ['data-cl-product-title'])),
        product_handle: metadata.product_handle,
        product_variant_id: metadata.product_variant_id,
        collection_handle: metadata.collection_handle,
        collection_title: metadata.collection_title,
        page_type: metadata.page_type,
        content_type: metadata.content_type,
        show_id: metadata.show_id,
        show_name: metadata.show_name,
        show_city: metadata.show_city,
        show_region: metadata.show_region,
        show_country: metadata.show_country,
        ticket_vendor: metadata.ticket_vendor,
        song_title: metadata.song_title,
        artist_alias: metadata.artist_alias,
        video_id: safe((details && details.video_id) || firstAttribute(target, ['data-cl-video-id'])),
        video_title: safe((details && details.video_title) || firstAttribute(target, ['data-cl-video-title'])),
        video_url: cleanUrl((details && details.video_url) || ''),
        video_percent: Number(details && details.video_percent) > 0 ? Number(details.video_percent) : 0,
        video_threshold: safe((details && details.video_threshold) || ''),
        form_id: safe((details && details.form_id) || (form && form.id)),
        page_left_reason: safe(reason || (details && details.page_left_reason)),
        duration_seconds: elapsed,
        time_on_page_seconds: elapsed,
        engagement_seconds: eventType === 'page_engaged' || engaged ? elapsed : null,
        qualified_engagement: Boolean(eventType === 'page_engaged' || engaged),
        scroll_depth_percent: scrollDepthPercent()
      },
      consent: consent
    };
    return payload;
  }

  function deliver(payload, useBeacon) {
    if (!payload) return;
    var dedupeTarget = payload.event.video_id || payload.event.destination || payload.event.url;
    if (payload.event.form_id) dedupeTarget = payload.event.form_id + '|' + dedupeTarget;
    if (alreadySent(payload.event_type, dedupeTarget)) return;
    var body = JSON.stringify(payload);
    if (useBeacon && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(ENDPOINT, new Blob([body], {type: 'application/json'}))) return;
      } catch (error) {}
    }
    fetch(ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {'content-type': 'application/json'},
      body: body,
      keepalive: true
    }).catch(function () {});
  }

  function emit(eventType, details, form, target, reason, useBeacon) {
    deliver(signalPayload(eventType, details || {}, form, target, reason), Boolean(useBeacon));
  }

  function videoWatched(event) {
    var video = event && event.target;
    if (!video || video.tagName !== 'VIDEO' || video.__clVideoWatched) return;
    var current = Number(video.currentTime) || 0;
    var duration = Number(video.duration) || 0;
    var reached = current >= VIDEO_THRESHOLD_SECONDS || (isFinite(duration) && duration > 0 && current / duration >= VIDEO_THRESHOLD_PERCENT);
    if (!reached) return;
    video.__clVideoWatched = true;
    emit('video_watched', {
      placement: 'video_watch_threshold',
      content_type: video.getAttribute('data-cl-content-type') || 'video',
      video_id: video.getAttribute('data-cl-video-id') || video.currentSrc || video.getAttribute('src') || 'video',
      video_title: video.getAttribute('data-cl-video-title') || video.getAttribute('aria-label') || video.getAttribute('title') || 'video',
      video_url: video.currentSrc || video.getAttribute('src') || '',
      video_percent: isFinite(duration) && duration > 0 ? Math.round((current / duration) * 100) : 0,
      video_threshold: current >= VIDEO_THRESHOLD_SECONDS ? '30_seconds' : '50_percent'
    }, null, video);
  }

  function qualifiedEngagement() {
    if (engaged || document.visibilityState === 'hidden') return;
    var height = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    var depth = height ? (window.scrollY + window.innerHeight) / height : 0;
    if (Date.now() - startTime >= 30000 || depth >= 0.5) {
      engaged = true;
      emit('page_engaged', {placement: 'qualified_page_engagement', click_target: '30_seconds_or_50_percent_scroll'});
    }
  }

  function emitPageViewed() {
    emit('page_viewed', {placement: 'page_view', url: window.location.href, click_target: pageType()});
  }

  var startTime = Date.now();

  document.addEventListener('click', function (event) {
    var link = linkFor(event.target);
    var tracked = link || buttonFor(event.target);
    var eventType = eventTypeFor(tracked);
    if (!tracked || !eventType) {
      var interestButton = event.target && event.target.closest ? event.target.closest('[data-cl-network-open]') : null;
      var interestHost = interestButton && interestButton.closest ? interestButton.closest('[data-cl-interest]') : null;
      var interest = firstAttribute(interestHost || interestButton, ['data-cl-interest', 'data-cl-network-context']);
      if (!interest) return;
      emit('interest_selected', {placement: 'interest_selector', interest: interest, click_target: interest}, null, interestHost || interestButton);
      return;
    }
    navigating = true;
    window.setTimeout(function () { navigating = false; }, 1500);
    emit(eventType, {
      placement: tracked.getAttribute('data-cl-placement') || eventType,
      campaign: tracked.getAttribute('data-cl-campaign') || campaign(),
      content_type: tracked.getAttribute('data-cl-content-type') || '',
      destination: linkDestination(tracked),
      url: linkDestination(tracked),
      click_target: (tracked.getAttribute('aria-label') || tracked.textContent || '').trim()
    }, null, tracked);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-cl-interest], input[name="network_interests"], input[name="interest"]')) return;
    emit('interest_selected', {
      placement: input.getAttribute('data-cl-placement') || 'interest_selector',
      interest: input.value,
      click_target: input.value
    }, input.form, null);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!signalForm(form)) return;
    emit('form_submitted', {
      placement: form.getAttribute('data-cl-placement') || 'email_form',
      form_id: form.id || form.getAttribute('name') || 'email_form',
      click_target: 'form_submitted'
    }, form, form);
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (hiddenTimer) window.clearTimeout(hiddenTimer);
      hiddenTimer = window.setTimeout(function () {
        hiddenTimer = null;
        if (leftSent || navigating) return;
        leftSent = true;
        emit('page_left', {placement: 'page_exit'}, null, null, 'visibility_hidden', true);
      }, 1500);
    } else if (hiddenTimer) {
      window.clearTimeout(hiddenTimer);
      hiddenTimer = null;
    }
  });

  window.addEventListener('pagehide', function () {
    if (hiddenTimer) {
      window.clearTimeout(hiddenTimer);
      hiddenTimer = null;
    }
    if (leftSent || navigating) return;
    leftSent = true;
    emit('page_left', {placement: 'page_exit'}, null, null, 'pagehide', true);
  }, {capture: true});

  document.addEventListener('timeupdate', videoWatched, true);
  document.addEventListener('ended', videoWatched, true);
  window.addEventListener('scroll', qualifiedEngagement, {passive: true});
  window.setTimeout(qualifiedEngagement, 30000);
  currentAttribution();
  window.setTimeout(emitPageViewed, 0);
}());
